import { useState } from "react";
import { useV2ListChangeOrdersQuery } from "@generated";
import type { ChangeOrder } from "../types";
import { toChangeOrder } from "./useChangeOrder";

const PAGE_SIZE = 25;

// A parent project's change orders, newest first, 25 per page.
export const useChangeOrdersList = (projectId: string) => {
  const [page, setPage] = useState(1);
  const { data, isLoading, isFetching, error, refetch } =
    useV2ListChangeOrdersQuery(
      {
        filter: { "parent-project": projectId },
        sort: ["-number"],
        include: ["user"],
        page: { number: page, size: PAGE_SIZE },
      },
      { refetchOnMountOrArgChange: true }
    );

  const rows: ChangeOrder[] = (data?.data ?? []).map((r) =>
    toChangeOrder(r, data?.included)
  );
  const totalRows = data?.meta?.["record-count"] ?? rows.length;
  const totalPages =
    data?.meta?.["page-count"] ?? Math.max(1, Math.ceil(totalRows / PAGE_SIZE));

  return {
    rows,
    totalRows,
    totalPages,
    page,
    setPage,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};

export default useChangeOrdersList;
